module.exports = __webpack_public_path__ + "img/badge_color_hs-finaid.2005d816.svg";